__turbopack_context__.v({
  "madeWith": "AboutPageContent-module__DldbzW__madeWith",
  "packageItem": "AboutPageContent-module__DldbzW__packageItem",
  "packageLabel": "AboutPageContent-module__DldbzW__packageLabel",
  "packageList": "AboutPageContent-module__DldbzW__packageList",
  "packageVersion": "AboutPageContent-module__DldbzW__packageVersion",
  "packageVersionWrapper": "AboutPageContent-module__DldbzW__packageVersionWrapper",
  "seeWorkCta": "AboutPageContent-module__DldbzW__seeWorkCta",
  "stackLogo": "AboutPageContent-module__DldbzW__stackLogo",
  "stackLogos": "AboutPageContent-module__DldbzW__stackLogos",
  "versioningInner": "AboutPageContent-module__DldbzW__versioningInner",
  "versioningSection": "AboutPageContent-module__DldbzW__versioningSection",
  "visuallyHidden": "AboutPageContent-module__DldbzW__visuallyHidden",
});
